import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=6f972961"
import script from "./fullscreen.vue?vue&type=script&lang=ts"
export * from "./fullscreen.vue?vue&type=script&lang=ts"
import style0 from "./fullscreen.vue?vue&type=style&index=0&id=6f972961&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports